export default __webpack_public_path__ + "images/90887bdb96aa052645b6930c2a3c67ce-dean_van_niekerk.png";